// extracted by mini-css-extract-plugin
export default {"btn":"SubmitBtn_btn__pDVZS","form_control":"SubmitBtn_form_control__JUh6r","attachmentBtn":"SubmitBtn_attachmentBtn__iS-2a"};